import PolicyPage from "@/components/shared/PolicyPage";
import { COMPANY, POLICY } from "@/config/company";

const sections = [
  {
    h: "Where we deliver",
    p: ["We run our own delivery network across South India, including remote mandals of Andhra Pradesh and Telangana, and deliver across India and internationally through trusted partner carriers. Serviceability is checked against the pickup and delivery pincode when you book."],
  },
  {
    h: "Delivery timelines",
    ul: [
      "On our own network across South India, parcels are normally delivered in 24 to 48 hours from pickup.",
      "Deliveries to other parts of India and abroad depend on the partner carrier and the route; the expected time is shown at booking.",
      "Timelines are estimates and start from pickup, not from booking. They do not include Sundays and public holidays where the carrier does not operate.",
      "Delays can be caused by weather, strikes, festivals and public holidays, road or airport closures, customs or regulatory checks, an incorrect or incomplete address, or the receiver being unavailable.",
    ],
  },
  {
    h: "Pickup",
    p: ["You choose a pickup date and slot when booking. Pickups requested after the daily cutoff move to the next working day. Goods must be packed, labelled and ready, with the invoice and, where required, the e-way bill, when our agent arrives."],
  },
  {
    h: "Delivery attempts and returns",
    ul: [
      "We make delivery attempts as per the carrier's rules and contact the receiver on the number given.",
      "If delivery fails because of a wrong address, an unreachable receiver or a refusal, the shipment may be held, re-attempted or returned to the sender, and extra charges may apply.",
    ],
  },
  {
    h: "Prohibited and restricted items",
    p: ["The following cannot be sent through Sendtoo:"],
    ul: [
      "Explosives, fireworks, firearms, ammunition and weapons;",
      "Narcotics, psychotropic substances and any other illegal goods;",
      "Flammable, corrosive, toxic, radioactive or other hazardous materials;",
      "Cash, currency notes, negotiable instruments, bullion and unset precious stones, unless specifically agreed in writing;",
      "Live animals and plants, perishable food and human remains, unless a special service has been agreed;",
      "Counterfeit goods, pirated material and anything whose carriage is restricted by law;",
      "Any item that is not accompanied by the documents required by law (for example an e-way bill for goods above the prescribed value).",
    ],
  },
  {
    h: "Packing and labelling",
    p: ["Pack goods so they can withstand normal handling and stacking. Fragile goods must be marked and cushioned. Put the receiver's full name, address, pincode and phone number on every box. We may refuse or repack goods that are not safe to carry."],
  },
  {
    h: "Documents",
    p: ["Shipments above the prescribed value or weight need the seller's invoice or delivery challan, and an e-way bill where applicable. Please make sure the pincode, city and address are correct and agree with each other: a wrong address can lead to delays, cancellation or extra charges."],
  },
  {
    h: "Loss or damage claims",
    ul: [
      `Report any loss or damage in writing within ${POLICY.claimDays} of delivery (or of the expected delivery date for a lost shipment) to ${COMPANY.email}, with the order or LR number, invoice and photographs of the goods and packing.`,
      "Compensation depends on the insurance or carrier-risk option chosen at booking and on the Terms & Conditions. Without such cover, liability is limited as described there.",
    ],
  },
  {
    h: "Tracking and support",
    p: [`You can track a shipment on sendtoo.in/track with its order or LR number. For help, contact ${COMPANY.phone} or ${COMPANY.email}.`],
  },
];

export default function ShippingPolicy() {
  return <PolicyPage testId="shipping-policy-page" title="Shipping & Service Policy" intro="How Sendtoo picks up, moves and delivers your shipments, and what we cannot carry." sections={sections} />;
}
